import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { AUDIT_TOKENS } from "../../theme/auditTokens";
import { formatDateTimeInZone } from "../../utils/timeZone";
import { formatNumber } from "@/utilities/formatNumber";

interface Props {
  updatedAt?: Date;
  timeZone: string;
  /** Unknown (undefined) while the vehicle list loads or failed: shown as "—", never as 0. */
  vehicleCount: number | undefined;
  tripCount: number | undefined;
  groupFilterActive: boolean;
  refreshing: boolean;
}

/** Data age, vehicles and entries of the period and the time zone, in one muted line. */
export function StatusMeta({ updatedAt, timeZone, vehicleCount, tripCount, groupFilterActive, refreshing }: Props) {
  const { t, i18n } = useTranslation();
  const number = (value: number | undefined) => (value === undefined ? "—" : formatNumber(value, i18n.language));

  return (
    <Box
      component="span"
      sx={{
        fontSize: 12,
        color: AUDIT_TOKENS.muted,
        "& b": { color: AUDIT_TOKENS.text, fontWeight: 600, fontVariantNumeric: "tabular-nums" },
      }}
    >
      {t("logbookAudit.meta.updated")}{" "}
      <b>{updatedAt ? formatDateTimeInZone(updatedAt, timeZone) : refreshing ? t("logbookAudit.meta.loading") : "—"}</b>
      {updatedAt ? ` ${t("logbookAudit.meta.clock")}` : ""} · <b>{number(vehicleCount)}</b>{" "}
      {t("logbookAudit.meta.vehicles", { count: vehicleCount ?? 0 })} · <b>{number(tripCount)}</b>{" "}
      {t("logbookAudit.meta.tripsInPeriod", { count: tripCount ?? 0 })}
      {groupFilterActive ? ` (${t("logbookAudit.meta.groupFilterActive")})` : ""}{" · "}
      {t("logbookAudit.meta.timeZone", { zone: timeZone })}
    </Box>
  );
}
